<div class="layout-fluid-constrained layout-align-center">
  <div class="trust-items-wrapper">
    @for (loanApplicationStep of this.loanApplicationSteps; track $index) {
      <div class="trust-item item-{{$index}}">
        <div class="name">{{ loanApplicationStep.name }}</div>
        <div class="text">{{ loanApplicationStep.text }}</div>
      </div>
    }
  </div>
</div>
